<table class="ir-plugin-table">
  <tr *ngIf="config?.Label">
    <td class="plugin-table-cell">
      <span>
        <strong>{{ config.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="preparation && preparation >= 0">
    <td class="plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationpreparationneeded.preparation' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ preparation | preparation }}</span>
      </p>
    </td>
  </tr>
</table>
